import { createSelector } from 'reselect';
import InterchangeDetailsColumns from '../../containers/InterchangeDetailsColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.INTERCHANGE_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.INTERCHANGE_DETAILS.isLoading;

export const getData =
  ReportDefinitions.INTERCHANGE_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, InterchangeDetailsColumns);
